<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <div v-if="positionLeft" class="left_position">
        <md-avatar class="avatar_left">
          <img src="/img/enginer_icon.png" :title="dateTimeFormat(timestamp)" />
        </md-avatar>
        <badge :title="dateTimeFormat(timestamp)" type="info" >{{msg}}</badge>
      </div>

      <div
        v-else
        class="right_position"
        @mouseover="showVertButton = true"
        @mouseleave="showVertButton = false"
      >
        <!-- <md-button
          v-show="showVertButton"
          style="height: 30px;"
          class="md-button md-just-icon md-simple"
        >
          <md-icon>more_vert</md-icon>
        </md-button> -->
        <badge :title="dateTimeFormat(timestamp)" type="info">{{msg}}</badge>
        <md-avatar class="avatar_right">
          <img src="/img/dispatch-icon.png" :title="dateTimeFormat(timestamp)" />
        </md-avatar>

        <!-- Message delivered to backend -->
        <md-icon v-show="stage == 1" style="font-size: 18px !important;" alt="Sending in progress" title="Sending in progress">radio_button_unchecked</md-icon>

        <!-- Message delivered to Lora client -->
        <md-icon v-show="stage == 2" style="font-size: 18px !important;" alt="Message on LoRa client" title="Message on LoRa client">check_circle_outline</md-icon>

        <!-- Message delivered to mobile APP -->
        <md-icon v-show="stage == 3" style="font-size: 18px !important;" alt="Message in mobile APP" title="Message in mobile APP">check_circle</md-icon>

        <!-- Seen by user -->
        <md-icon v-show="stage == 4" style="font-size: 18px !important;" alt="Seen by user" title="Seen by user">account_circle</md-icon>
      </div>
    </div>
  </div>
</template>

<script>
import format from "date-fns/format";
import { Badge } from "@/components";

export default {
  components: {
    Badge
  },
  props: {
    msg: {
      type: String,
      default: ""
    },
    timestamp: {
      type: Number,
      default: new Date().getTime() / 1000
    },
    positionLeft: {
      type: Boolean,
      default: false
    },
    stage: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      showVertButton: false
    };
  },
  methods: {
    dateTimeFormat(value) {
      return format(value * 1000, "DD-MM-YYYY HH:mm:ss");
    }
  }
};
</script>

<style scoped>
.badge {
  white-space: normal;
  text-transform: unset;
  font-size: 14px;
  overflow-wrap: anywhere;
  display: inline-flex;
  align-items: center;
}

.left_position {
  float: left;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
}

.right_position {
  float: right;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
}

.avatar_left {
  margin-right: 10px;
}

.avatar_right {
  margin-left: 10px;
}

i {
  margin-top: 0px;
  margin-bottom: 0px;
}

.md-icon.md-theme-default.md-icon-font {
  color: #00bcd4;
}
</style>